/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import windowsFilled from '@iconify/icons-ant-design/windows-filled';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
//import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CountUp from 'react-countup';
import TokenDecoder from '../../../helpers/TokenDecoder';

// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import VPUDashboardService from './VPUDashboardService'


// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(5, 0),
    color: theme.palette.warning.darker,
    backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.warning.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
        theme.palette.warning.dark,
        0.24
    )} 100%)`
}));

// ----------------------------------------------------------------------

export default function ReorderCountVPU() {

    // const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

    const [count, setCount] = useState(0);

    async function GetReturnOrderCount() {
        const response = await VPUDashboardService.GetReturnOrderCountToVPUDashboard();
        if (response.length > 0) {
            setCount(response[0].returnOrderCount);
        }
    }
    useEffect(() => {
        GetReturnOrderCount();
    }, [])



    return (
        <RootStyle>
            <IconWrapperStyle>
                {/* <Icon icon={windowsFilled} width={24} height={24} /> */}
                <AssignmentIndIcon fontSize='large' width={50} height={60} />
            </IconWrapperStyle>
            <Typography variant="h3"><CountUp end={count} /></Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                Reorder Count
            </Typography>
        </RootStyle>
    );
}
